module.exports = __webpack_public_path__ + "img/nostock.f194544c.png";